import { __assign } from "tslib";
import { SENSITIVE_STRING, isa as __isa } from "@aws-sdk/smithy-client";
export var AppliedTerminology;
(function (AppliedTerminology) {
    AppliedTerminology.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    AppliedTerminology.isa = function (o) { return __isa(o, "AppliedTerminology"); };
})(AppliedTerminology || (AppliedTerminology = {}));
export var DeleteTerminologyRequest;
(function (DeleteTerminologyRequest) {
    DeleteTerminologyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteTerminologyRequest.isa = function (o) { return __isa(o, "DeleteTerminologyRequest"); };
})(DeleteTerminologyRequest || (DeleteTerminologyRequest = {}));
export var DescribeTextTranslationJobRequest;
(function (DescribeTextTranslationJobRequest) {
    DescribeTextTranslationJobRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DescribeTextTranslationJobRequest.isa = function (o) { return __isa(o, "DescribeTextTranslationJobRequest"); };
})(DescribeTextTranslationJobRequest || (DescribeTextTranslationJobRequest = {}));
export var DescribeTextTranslationJobResponse;
(function (DescribeTextTranslationJobResponse) {
    DescribeTextTranslationJobResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DescribeTextTranslationJobResponse.isa = function (o) {
        return __isa(o, "DescribeTextTranslationJobResponse");
    };
})(DescribeTextTranslationJobResponse || (DescribeTextTranslationJobResponse = {}));
export var DetectedLanguageLowConfidenceException;
(function (DetectedLanguageLowConfidenceException) {
    DetectedLanguageLowConfidenceException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DetectedLanguageLowConfidenceException.isa = function (o) {
        return __isa(o, "DetectedLanguageLowConfidenceException");
    };
})(DetectedLanguageLowConfidenceException || (DetectedLanguageLowConfidenceException = {}));
export var EncryptionKey;
(function (EncryptionKey) {
    EncryptionKey.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EncryptionKey.isa = function (o) { return __isa(o, "EncryptionKey"); };
})(EncryptionKey || (EncryptionKey = {}));
export var EncryptionKeyType;
(function (EncryptionKeyType) {
    EncryptionKeyType["KMS"] = "KMS";
})(EncryptionKeyType || (EncryptionKeyType = {}));
export var GetTerminologyRequest;
(function (GetTerminologyRequest) {
    GetTerminologyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetTerminologyRequest.isa = function (o) { return __isa(o, "GetTerminologyRequest"); };
})(GetTerminologyRequest || (GetTerminologyRequest = {}));
export var GetTerminologyResponse;
(function (GetTerminologyResponse) {
    GetTerminologyResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetTerminologyResponse.isa = function (o) { return __isa(o, "GetTerminologyResponse"); };
})(GetTerminologyResponse || (GetTerminologyResponse = {}));
export var ImportTerminologyRequest;
(function (ImportTerminologyRequest) {
    ImportTerminologyRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.TerminologyData && { TerminologyData: TerminologyData.filterSensitiveLog(obj.TerminologyData) }))); };
    ImportTerminologyRequest.isa = function (o) { return __isa(o, "ImportTerminologyRequest"); };
})(ImportTerminologyRequest || (ImportTerminologyRequest = {}));
export var ImportTerminologyResponse;
(function (ImportTerminologyResponse) {
    ImportTerminologyResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ImportTerminologyResponse.isa = function (o) { return __isa(o, "ImportTerminologyResponse"); };
})(ImportTerminologyResponse || (ImportTerminologyResponse = {}));
export var InputDataConfig;
(function (InputDataConfig) {
    InputDataConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    InputDataConfig.isa = function (o) { return __isa(o, "InputDataConfig"); };
})(InputDataConfig || (InputDataConfig = {}));
export var InternalServerException;
(function (InternalServerException) {
    InternalServerException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    InternalServerException.isa = function (o) { return __isa(o, "InternalServerException"); };
})(InternalServerException || (InternalServerException = {}));
export var InvalidFilterException;
(function (InvalidFilterException) {
    InvalidFilterException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    InvalidFilterException.isa = function (o) { return __isa(o, "InvalidFilterException"); };
})(InvalidFilterException || (InvalidFilterException = {}));
export var InvalidParameterValueException;
(function (InvalidParameterValueException) {
    InvalidParameterValueException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    InvalidParameterValueException.isa = function (o) { return __isa(o, "InvalidParameterValueException"); };
})(InvalidParameterValueException || (InvalidParameterValueException = {}));
export var InvalidRequestException;
(function (InvalidRequestException) {
    InvalidRequestException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    InvalidRequestException.isa = function (o) { return __isa(o, "InvalidRequestException"); };
})(InvalidRequestException || (InvalidRequestException = {}));
export var JobDetails;
(function (JobDetails) {
    JobDetails.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    JobDetails.isa = function (o) { return __isa(o, "JobDetails"); };
})(JobDetails || (JobDetails = {}));
export var JobStatus;
(function (JobStatus) {
    JobStatus["COMPLETED"] = "COMPLETED";
    JobStatus["COMPLETED_WITH_ERROR"] = "COMPLETED_WITH_ERROR";
    JobStatus["FAILED"] = "FAILED";
    JobStatus["IN_PROGRESS"] = "IN_PROGRESS";
    JobStatus["STOPPED"] = "STOPPED";
    JobStatus["STOP_REQUESTED"] = "STOP_REQUESTED";
    JobStatus["SUBMITTED"] = "SUBMITTED";
})(JobStatus || (JobStatus = {}));
export var LimitExceededException;
(function (LimitExceededException) {
    LimitExceededException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    LimitExceededException.isa = function (o) { return __isa(o, "LimitExceededException"); };
})(LimitExceededException || (LimitExceededException = {}));
export var ListTerminologiesRequest;
(function (ListTerminologiesRequest) {
    ListTerminologiesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListTerminologiesRequest.isa = function (o) { return __isa(o, "ListTerminologiesRequest"); };
})(ListTerminologiesRequest || (ListTerminologiesRequest = {}));
export var ListTerminologiesResponse;
(function (ListTerminologiesResponse) {
    ListTerminologiesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListTerminologiesResponse.isa = function (o) { return __isa(o, "ListTerminologiesResponse"); };
})(ListTerminologiesResponse || (ListTerminologiesResponse = {}));
export var ListTextTranslationJobsRequest;
(function (ListTextTranslationJobsRequest) {
    ListTextTranslationJobsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListTextTranslationJobsRequest.isa = function (o) { return __isa(o, "ListTextTranslationJobsRequest"); };
})(ListTextTranslationJobsRequest || (ListTextTranslationJobsRequest = {}));
export var ListTextTranslationJobsResponse;
(function (ListTextTranslationJobsResponse) {
    ListTextTranslationJobsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListTextTranslationJobsResponse.isa = function (o) { return __isa(o, "ListTextTranslationJobsResponse"); };
})(ListTextTranslationJobsResponse || (ListTextTranslationJobsResponse = {}));
export var MergeStrategy;
(function (MergeStrategy) {
    MergeStrategy["OVERWRITE"] = "OVERWRITE";
})(MergeStrategy || (MergeStrategy = {}));
export var OutputDataConfig;
(function (OutputDataConfig) {
    OutputDataConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    OutputDataConfig.isa = function (o) { return __isa(o, "OutputDataConfig"); };
})(OutputDataConfig || (OutputDataConfig = {}));
export var ResourceNotFoundException;
(function (ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ResourceNotFoundException.isa = function (o) { return __isa(o, "ResourceNotFoundException"); };
})(ResourceNotFoundException || (ResourceNotFoundException = {}));
export var ServiceUnavailableException;
(function (ServiceUnavailableException) {
    ServiceUnavailableException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ServiceUnavailableException.isa = function (o) { return __isa(o, "ServiceUnavailableException"); };
})(ServiceUnavailableException || (ServiceUnavailableException = {}));
export var StartTextTranslationJobRequest;
(function (StartTextTranslationJobRequest) {
    StartTextTranslationJobRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    StartTextTranslationJobRequest.isa = function (o) { return __isa(o, "StartTextTranslationJobRequest"); };
})(StartTextTranslationJobRequest || (StartTextTranslationJobRequest = {}));
export var StartTextTranslationJobResponse;
(function (StartTextTranslationJobResponse) {
    StartTextTranslationJobResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    StartTextTranslationJobResponse.isa = function (o) { return __isa(o, "StartTextTranslationJobResponse"); };
})(StartTextTranslationJobResponse || (StartTextTranslationJobResponse = {}));
export var StopTextTranslationJobRequest;
(function (StopTextTranslationJobRequest) {
    StopTextTranslationJobRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    StopTextTranslationJobRequest.isa = function (o) { return __isa(o, "StopTextTranslationJobRequest"); };
})(StopTextTranslationJobRequest || (StopTextTranslationJobRequest = {}));
export var StopTextTranslationJobResponse;
(function (StopTextTranslationJobResponse) {
    StopTextTranslationJobResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    StopTextTranslationJobResponse.isa = function (o) { return __isa(o, "StopTextTranslationJobResponse"); };
})(StopTextTranslationJobResponse || (StopTextTranslationJobResponse = {}));
export var Term;
(function (Term) {
    Term.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Term.isa = function (o) { return __isa(o, "Term"); };
})(Term || (Term = {}));
export var TerminologyData;
(function (TerminologyData) {
    TerminologyData.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.File && { File: SENSITIVE_STRING }))); };
    TerminologyData.isa = function (o) { return __isa(o, "TerminologyData"); };
})(TerminologyData || (TerminologyData = {}));
export var TerminologyDataFormat;
(function (TerminologyDataFormat) {
    TerminologyDataFormat["CSV"] = "CSV";
    TerminologyDataFormat["TMX"] = "TMX";
})(TerminologyDataFormat || (TerminologyDataFormat = {}));
export var TerminologyDataLocation;
(function (TerminologyDataLocation) {
    TerminologyDataLocation.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    TerminologyDataLocation.isa = function (o) { return __isa(o, "TerminologyDataLocation"); };
})(TerminologyDataLocation || (TerminologyDataLocation = {}));
export var TerminologyProperties;
(function (TerminologyProperties) {
    TerminologyProperties.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    TerminologyProperties.isa = function (o) { return __isa(o, "TerminologyProperties"); };
})(TerminologyProperties || (TerminologyProperties = {}));
export var TextSizeLimitExceededException;
(function (TextSizeLimitExceededException) {
    TextSizeLimitExceededException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    TextSizeLimitExceededException.isa = function (o) { return __isa(o, "TextSizeLimitExceededException"); };
})(TextSizeLimitExceededException || (TextSizeLimitExceededException = {}));
export var TextTranslationJobFilter;
(function (TextTranslationJobFilter) {
    TextTranslationJobFilter.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    TextTranslationJobFilter.isa = function (o) { return __isa(o, "TextTranslationJobFilter"); };
})(TextTranslationJobFilter || (TextTranslationJobFilter = {}));
export var TextTranslationJobProperties;
(function (TextTranslationJobProperties) {
    TextTranslationJobProperties.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    TextTranslationJobProperties.isa = function (o) { return __isa(o, "TextTranslationJobProperties"); };
})(TextTranslationJobProperties || (TextTranslationJobProperties = {}));
export var TooManyRequestsException;
(function (TooManyRequestsException) {
    TooManyRequestsException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    TooManyRequestsException.isa = function (o) { return __isa(o, "TooManyRequestsException"); };
})(TooManyRequestsException || (TooManyRequestsException = {}));
export var TranslateTextRequest;
(function (TranslateTextRequest) {
    TranslateTextRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    TranslateTextRequest.isa = function (o) { return __isa(o, "TranslateTextRequest"); };
})(TranslateTextRequest || (TranslateTextRequest = {}));
export var TranslateTextResponse;
(function (TranslateTextResponse) {
    TranslateTextResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    TranslateTextResponse.isa = function (o) { return __isa(o, "TranslateTextResponse"); };
})(TranslateTextResponse || (TranslateTextResponse = {}));
export var UnsupportedLanguagePairException;
(function (UnsupportedLanguagePairException) {
    UnsupportedLanguagePairException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UnsupportedLanguagePairException.isa = function (o) { return __isa(o, "UnsupportedLanguagePairException"); };
})(UnsupportedLanguagePairException || (UnsupportedLanguagePairException = {}));
//# sourceMappingURL=index.js.map